module.exports = __webpack_public_path__ + "img/am_get.738eeba.png";